import { call, takeLatest, put, takeEvery } from 'redux-saga/effects';
import { deleteStoreConnect, getAllOrganization, getBrandList, getStoreConnectServiceCall, getStoresDetailsFromBrands, getStoresFromBrands, loginUsingCode, postStoreConnect } from '../../api/otter.api';
import { authUserWithCode, authUserWithCodeFailure, authUserWithCodeSuccess, merchantGetOrganization, merchantGetOrganizationBrands, merchantGetOrganizationBrandsFailure, merchantGetOrganizationBrandsSuccess, merchantGetOrganizationFailure, merchantGetBrandList, merchantGetBrandListSuccess, merchantGetOrganizationSuccess, merchantGetStoreListFromBrand, merchantGetStoreListFromBrandSuccess, merchantGetStoreListFromBrandFailure, merchantGetStoresDetailsOfBrandSuccess, merchantGetStoresDetailsOfBrandFailure, merchantGetStoresDetailsOfBrand, getStoreConnection, postStoreConnection, deleteStoreConnection, getStoreConnectionSuccess, getStoreConnectionFailure, postStoreConnectionSuccess, postStoreConnectionFailure, deleteStoreConnectionSuccess, deleteStoreConnectionFailure, merchantGetStoreCountFromBrandSuccess, merchantGetStoreCountFromBrandFailure, merchantGetStoreCountFromBrand, getAppAccessToken, getAppAccessTokenSuccess, getAppAccessTokenFailure, merchantGetBrandListFailure } from '../actions/merchantAction';
import { getAppAccessTokenServiceCall } from '../../api/merchantAPI';

export function* makeUserWithCodeAuthCall(action) {
	try {
		const response = yield call(loginUsingCode, action);
		yield put(authUserWithCodeSuccess(response));
	  } catch (e) {
		yield put(authUserWithCodeFailure(e));
	}
}

export function* makeMerchantOrganizationCall(action) {
	try {
		const response = yield call(getAllOrganization, action);
		yield put(merchantGetOrganizationSuccess(response));

		if (response?.status === 200) {
			yield put(merchantGetOrganizationSuccess(response.data));
		 } else {
			response?.code === 'ECONNABORTED' ? yield put(merchantGetOrganizationFailure(response)) : yield put(merchantGetOrganizationFailure(response.response));
		 }
	} catch (e) {
		// yield put(merchantGetOrganizationFailure(e));
		yield put(merchantGetOrganizationFailure(e));
	}
}

export function* makeMerchantBrandListCall(action) {
	try {
		const response = yield call(getBrandList, action);
		
		if (response?.status === 200) {
			yield put(merchantGetBrandListSuccess(response.data));
		 } else {
			response?.code === 'ECONNABORTED' ? yield put(merchantGetBrandListFailure(response)) : yield put(merchantGetBrandListFailure(response.response));
		 }
	} catch (e) {
		// yield put(merchantGetBrandListFailure(e));
		yield put(merchantGetBrandListFailure(e));
	}
}

export function* makeMerchantOrganizationStoreFromBrandsCall(action) {
	try {
		const response = yield call(getStoresFromBrands, action);
		
		if (response?.status === 200) {
			yield put(merchantGetStoreListFromBrandSuccess(response.data));
		 } else {
			response?.code === 'ECONNABORTED' ? yield put(merchantGetStoreListFromBrandFailure(response)) : yield put(merchantGetStoreListFromBrandFailure(response.response));
		 }
	} catch (e) {
		// yield put(merchantGetStoreListFromBrandFailure(e));
		yield put(merchantGetStoreListFromBrandFailure(e));
	}
}

export function* makeMerchantStoreCountForDisplayFromBrandsCall(action) {
	try {
		const response = yield call(getStoresFromBrands, action);
		
		if (response?.status === 200) {
			yield put(merchantGetStoreCountFromBrandSuccess(response.data));
		 } else {
			response?.code === 'ECONNABORTED' ? yield put(merchantGetStoreCountFromBrandFailure(response)) : yield put(merchantGetStoreCountFromBrandFailure(response.response));
		 }
	} catch (e) {
		// yield put(merchantGetStoreCountFromBrandFailure(e));
		yield put(merchantGetStoreCountFromBrandFailure(e));
	}
}

export function* makeMerchantOrganizationStoreDetailsFromBrandsCall(action) {
	try {
		const response = yield call(getStoresDetailsFromBrands, action);
		if (response?.status === 200) {
			yield put(merchantGetStoresDetailsOfBrandSuccess(response.data));
		 } else {
			response?.code === 'ECONNABORTED' ? yield put(merchantGetStoresDetailsOfBrandFailure(response)) : yield put(merchantGetStoresDetailsOfBrandFailure(response.response));
		 }
	} catch (e) {
		// yield put(merchantGetStoresDetailsOfBrandFailure(e));
		yield put(merchantGetStoresDetailsOfBrandFailure(e));
	}
}

export function* getStoreConnectionCall(action) {
	try {
		const response = yield call(getStoreConnectServiceCall, action);
		if (response?.status === 200) {
			yield put(getStoreConnectionSuccess(response));
		 } else {
			response?.code === 'ECONNABORTED' ? yield put(getStoreConnectionFailure(response)) : yield put(getStoreConnectionFailure({...response.response.data, storeID : response.storeID}));
		 }
	} catch (e) {
		// yield put(merchantGetStoresDetailsOfBrandFailure(e));
		yield put(getStoreConnectionFailure(e));
	}
}

export function* postStoreConnectionCall(action) {
	try {
		const response = yield call(postStoreConnect, action);
		if (response?.status === 200) {
			yield put(postStoreConnectionSuccess(response));
		 } else {
			response?.code === 'ECONNABORTED' ? yield put(postStoreConnectionFailure(response)) : yield put(postStoreConnectionFailure({...response.response.data, storeID : response.storeID}));
		 }
	} catch (e) {
		yield put(postStoreConnectionFailure(e));
	}
}

export function* deleteStoreConnectionCall(action) {
	try {
		const response = yield call(deleteStoreConnect, action);
		// yield put(deleteStoreConnectionSuccess(response));
		if (response?.status === 200) {
			yield put(deleteStoreConnectionSuccess(response));
		 } else {
			response?.code === 'ECONNABORTED' ? yield put(deleteStoreConnectionFailure(response)) : yield put(deleteStoreConnectionFailure({...response.response.data, storeID : response.storeID}));
		 }
	} catch (e) {
		// yield put(merchantGetStoresDetailsOfBrandFailure(e));
		yield put(deleteStoreConnectionFailure(e));
	}
}

export function* getAppAccessTokenCall(action) {
	try {
		const response = yield call(getAppAccessTokenServiceCall, action);
		if (response?.status === 200) {
			yield put(getAppAccessTokenSuccess(response.data));
		 } else {
			response?.code === 'ECONNABORTED' ? yield put(getAppAccessTokenFailure(response)) : yield put(getAppAccessTokenFailure(response));
		 }
	} catch (e) {
		yield put(getAppAccessTokenFailure(e));
	}
}

export function* merchantServiceSaga() {
	yield takeLatest(authUserWithCode, makeUserWithCodeAuthCall);
	yield takeLatest(merchantGetOrganization, makeMerchantOrganizationCall);
	yield takeLatest(merchantGetBrandList, makeMerchantBrandListCall);
    yield takeLatest(merchantGetStoreListFromBrand, makeMerchantOrganizationStoreFromBrandsCall);
    yield takeLatest(merchantGetStoreCountFromBrand, makeMerchantStoreCountForDisplayFromBrandsCall);
    yield takeLatest(merchantGetStoresDetailsOfBrand, makeMerchantOrganizationStoreDetailsFromBrandsCall);
    yield takeEvery(getStoreConnection, getStoreConnectionCall);
    yield takeLatest(postStoreConnection, postStoreConnectionCall);
    yield takeLatest(deleteStoreConnection, deleteStoreConnectionCall);
    yield takeLatest(getAppAccessToken, getAppAccessTokenCall);
}

export default merchantServiceSaga;
